export const FETCH_STYLIST_CARD_DATA = "FETCH_STYLIST_CARD_DATA";
export const FETCH_STYLIST_CARD_DATA_SUCCESS =
  "FETCH_STYLIST_CARD_DATA_SUCCESS";
export const FETCH_STYLIST_CARD_DATA_FAILURE =
  "FETCH_STYLIST_CARD_DATA_FAILURE";

export const FETCH_STYLIST_CARD_DATA_WITHOUT_TIME =
  "FETCH_STYLIST_CARD_DATA_WITHOUT_TIME";
export const FETCH_STYLIST_CARD_DATA_UPDATE_ERROR = "FETCH_STYLIST_CARD_DATA_UPDATE_ERROR";
